import React from 'react'
import { css } from '@emotion/core'
import { Checkbox, CheckboxProps } from '@/components/atoms/checkbox'
import { FrontTabletFontSize } from '@/constants/front-tablet-typography'
import { createSelfCheckinResponsiveStyle, FrontTabletResponsiveToken } from '@/utils/front-tablet-responsive-style'

export const FrontTabletSmallCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      {...props}
      style={css(
        {
          img: { width: FrontTabletFontSize.radioMini, height: FrontTabletFontSize.radioMini, marginRight: 0 },
          p: {
            marginLeft: 16,
            fontSize: FrontTabletFontSize.radioMiniLabel,
            fontWeight: 500,
            letterSpacing: 1,
            color: '#272727',
          },
        },
        createSelfCheckinResponsiveStyle({
          landscape13: { p: { fontSize: FrontTabletResponsiveToken.formLabelFontSize.landscape13, letterSpacing: 1.2 } },
        }),
      )}
    />
  )
}
